<template>
  <div class="second_item">
    <div class="second_item_left">
      <img :src="data.creator.avatar" />
    </div>
    <div class="second_item_right">
      <div class="second_item_right_top">
        <span class="user_name">{{data.creator.nickname}}</span>
        <div class="second_item_right_delete" @click="deleteFun()">删除记录</div>
      </div>
      <div class="second_item_right_content">{{data.replyComment}}</div>
      <div class="second_item_right_article" @click="toArticle()">
        <div class="img"><img :src="data.images[0]" /></div>
        <div class="title">{{data.title?data.title:data.content}}</div>
      </div>
      <!-- <div class="second_item_right_time">{{timeToStr(data.createdDate)}}</div> -->
    </div>
  </div>
</template>

<script>
import { timeToStr } from '@/assets/js/util'
export default {
  props:{
    data:{
      type:Object,
      default: null
    }
  },
  components: {
  },
  data () {
    return{
      deleteState: false,
      commentState: false,
      comment: '',
    }
  },
  created () {
  },
  methods: {
    timeToStr(time){
      return timeToStr(time)
    },
    toArticle(){
      if(!this.data.type){
        this.$router.push('/post?postId=' + this.data.id)
      }else if(this.data.type.value == "common"){
        this.$router.push('/article?articleId=' + this.data.id)
      }else{
        this.$router.push('/post?postId=' + this.data.id)
      }
    },
    deleteFun(){
      this.$store.commit('det_history_list',this.data)
    }
  }
}
</script>
<style scoped>
  .second_item{
  width: 770px;
  margin: 0 auto;
  margin-top: 22px;
  padding-bottom: 17px;
  position: relative;
  border-bottom: 1px solid #EBEBEB;
}
.second_item_left{
  width: 37px;
  height: 37px;
  position: absolute;
  top: 0;
  left: 0;
}
.second_item_left img{
  width: 37px;
  height: 37px;
  border-radius: 50%;
}
.second_item_right{
  width: 702px;
  margin-left: 68px;
}
.second_item_right_top{
  width: 100%;
  position: relative;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}
.second_item_right_top .user_name{
  font-size: 16px;
  font-weight: 400;
  color: #3399CC;
  line-height: 16px;
  margin-right: 29px;
}
.second_item_right_delete{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 16px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}
.second_item_right_content{
  font-size: 14px;
  font-weight: 300;
  color: #333333;
  line-height: 24px;
  padding-top: 9px;
  padding-bottom: 14px;
}
.second_item_right_article{
  width: 100%;
  height: 82px;
  background: #f6f6f6;
  border-radius: 10px;
  cursor: pointer;
}
.second_item_right_article div{
  display: inline-block;
}
.second_item_right_article .img{
  width: 105px;
  height: 81px;
  border-radius: 10px;
}
.second_item_right_article .img img{
  width: 105px;
  height: 81px;
  border-radius: 10px;
}
.second_item_right_article .title{
  width: 568px;
  height: 60px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 300;
  color: #333333;
  vertical-align: top;
  padding-left: 13px;
  padding-top: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.second_item_right_time{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  margin-top: 14px;
}
</style>